import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {GefConnectionDto} from '../../../../core/dtos/gef/gef-connection-dto';
import {SiteDTO} from '../../../../core/dtos/site-dto';
import {Auth2Service} from '../../../../core/services/security/auth2.service';
import {GefDuplicationDialogSupplier, GestionGefService} from '../../../../core/services/gef/gestion-gef.service';
import {ToastService} from '../../../../core/services/technique/toast.service';
import {UtilsService} from '../../../../core/utils/utils.service';
import {MSG_KEY, MSG_SEVERITY} from '../../../../core/constants';
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';

@Component({
  selector: 'yo-connections-gef-duplication-dialog',
  templateUrl: './connections-gef-duplication-dialog.component.html',
  standalone: false
})
export class ConnectionsGefDuplicationDialogComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  displayDialog = false;
  gefConnection: GefConnectionDto;
  sitesLocaux: SiteDTO[] = [];
  selectedSiteIds: number[] = [];

  subOpenDialog: Subscription;

  constructor(private auth2Svc: Auth2Service,
              private gestionGefSvc: GestionGefService,
              private toastSvc: ToastService,
              public utilsSvc: UtilsService) {
  }

  ngOnInit(): void {
    this.subOpenDialog = this.gestionGefSvc.openDuplicationDialog$
      .subscribe((supplier: GefDuplicationDialogSupplier) => {
        this.gefConnection = supplier.connection;
        const providerCode = supplier.connection?.gefProvider?.code;
        const siteListLocaux = this.auth2Svc.utilisateur.siteListLocaux;
        const siteListLocauxIds = new Set(siteListLocaux.map(s => s.id));
        const sitesDejaConfigures = new Set(
          (supplier.existingConnections ?? [])
            .filter(c => c.gefProvider?.code === providerCode && siteListLocauxIds.has(c.site?.id))
            .map(c => c.site?.id)
        );
        this.sitesLocaux = siteListLocaux.filter(s => !sitesDejaConfigures.has(s.id));
        this.selectedSiteIds = [];
        this.displayDialog = true;
      });
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpenDialog);
  }

  dupliquer(): void {
    if (!this.selectedSiteIds.length) {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, `Veuillez sélectionner au moins un site cible`);
      return;
    }
    this.gestionGefSvc.dupliquerGefConnection(this.gefConnection, this.selectedSiteIds)
      .subscribe(res => {
        if (res?.resultList?.length) {
          res.resultList.forEach(connection => {
            const site = this.sitesLocaux.find(s => s.id === connection.site?.id);
            if (site) { connection.site = {id: site.id, libelle: site.libelle} as any; }
            this.gestionGefSvc.announceGefConnectionSaved(connection, false);
          });
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS,
            `${res.resultList.length} configuration(s) dupliquée(s) avec succès`);
          this.closeDialog();
        }
      });
  }

  closeDialog(): void {
    this.displayDialog = false;
  }
}
